// extracted by mini-css-extract-plugin
export var header = "_w5-1";
export var maskBottom = "_w5-6";
export var maskMiddle = "_w5-7";
export var maskTop = "_w5-5";
export var root = "_w5-0";
export var scrollDownButton = "_w5-3";
export var scrollDownButtonHidden = "_w5-4";
export var viewport = "_w5-2";